import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { rtkQueryErrorLogger } from './slices';
import { authAPI } from './slices/auth';
import { dicomApi } from '../services/dicomService';
import { exploreApi } from '../services/exploreService';

export const store = configureStore({
  reducer: {
    [authAPI.reducerPath]: authAPI.reducer, // Authentication API
    [dicomApi.reducerPath]: dicomApi.reducer, // DICOM API
    [exploreApi.reducerPath]: exploreApi.reducer, // Explorer (browse + aggregates)
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      authAPI.middleware,
      dicomApi.middleware, // DICOM API middleware
      exploreApi.middleware,
      rtkQueryErrorLogger
    ),
});

setupListeners(store.dispatch);
